export default function TasksSolved() {
  const tasks = [
    { icon: 'ri-line-chart-line', title: 'Рост конверсии', desc: 'Увеличиваем процент закрытых сделок на каждом этапе воронки продаж' },
    { icon: 'ri-question-answer-line', title: 'Работа с возражениями', desc: 'Превращаем «дорого» и «я подумаю» в аргументированные ответы' },
    { icon: 'ri-search-eye-line', title: 'Выявление потребностей', desc: 'Учим задавать правильные вопросы и слышать истинные потребности клиента' },
    { icon: 'ri-vip-diamond-line', title: 'Продажа ценности', desc: 'Переход от продажи продукта к продаже ценности и решения проблем клиента' },
    { icon: 'ri-funds-line', title: 'Повышение среднего чека', desc: 'Техники допродаж, кросс-продаж и увеличения суммы сделки' },
    { icon: 'ri-discount-percent-line', title: 'Снижение скидок', desc: 'Защита цены, аргументация стоимости и управление переговорным процессом' },
    { icon: 'ri-phone-line', title: 'Холодные звонки', desc: 'Структура эффективного холодного звонка, скрипты и преодоление страха' },
    { icon: 'ri-chat-1-line', title: 'Продажи через переписку', desc: 'Деловая переписка, коммерческие предложения и работа в мессенджерах' },
    { icon: 'ri-heart-line', title: 'Удержание клиентов', desc: 'Построение долгосрочных отношений, работа с лояльностью и повторные продажи' },
    { icon: 'ri-user-voice-line', title: 'Переговоры', desc: 'Подготовка к переговорам, стратегия win-win, управление уступками' },
    { icon: 'ri-focus-2-line', title: 'Метод СПИН', desc: 'Ситуационные, проблемные, извлекающие и направляющие вопросы в продажах' },
    { icon: 'ri-smartphone-line', title: 'Телефонные продажи', desc: 'Полный цикл продажи по телефону: от первого контакта до закрытия сделки' },
    { icon: 'ri-rocket-line', title: 'Активные продажи', desc: 'Проактивный поиск клиентов, инициативные контакты и развитие воронки' },
    { icon: 'ri-computer-line', title: 'Работа с CRM', desc: 'Внедрение эффективных привычек работы в CRM для контроля и аналитики' },
    { icon: 'ri-user-settings-line', title: 'Самостоятельность менеджеров', desc: 'Развитие навыка принимать решения, а не ждать указаний руководителя' },
    { icon: 'ri-shield-check-line', title: 'Уверенность продавцов', desc: 'Снятие психологических барьеров, работа с синдромом самозванца' },
    { icon: 'ri-file-list-3-line', title: 'Скрипты продаж', desc: 'Разработка и внедрение эффективных разговорных сценариев продаж' },
    { icon: 'ri-bar-chart-box-line', title: 'Аналитика продаж', desc: 'Внедрение KPI, отслеживание метрик и управление на основе данных' },
  ];

  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="tasks" className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Какие задачи решает <strong>тренинг по продажам</strong>
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Каждая программа <strong>корпоративного обучения продажам</strong> разрабатывается под конкретные задачи бизнеса. Вот ключевые направления, в которых мы достигаем измеримых результатов.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {tasks.map((task, i) => (
            <div key={i} className="bg-white rounded-xl p-6 hover:shadow-md hover:-translate-y-0.5 transition-all duration-300 group cursor-default">
              <div className="w-11 h-11 bg-teal-100 rounded-lg flex items-center justify-center mb-4 group-hover:bg-teal-600 transition-colors duration-300 flex-shrink-0">
                <i className={`${task.icon} text-lg text-teal-600 group-hover:text-white transition-colors duration-300`}></i>
              </div>
              <h3 className="text-base font-bold text-gray-900 mb-2">{task.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{task.desc}</p>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <button
            onClick={() => scrollTo('contact')}
            className="bg-teal-600 text-white px-8 py-4 rounded-lg text-base font-semibold hover:bg-teal-700 transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
          >
            Обсудить задачи вашего отдела продаж
            <i className="ri-arrow-right-line"></i>
          </button>
        </div>
      </div>
    </section>
  );
}